import { render, staticRenderFns } from "./FooterSimpleModular.vue?vue&type=template&id=5fed4f15&scoped=true&"
import script from "./FooterSimpleModular.vue?vue&type=script&lang=js&"
export * from "./FooterSimpleModular.vue?vue&type=script&lang=js&"
import style0 from "./FooterSimpleModular.vue?vue&type=style&index=0&id=5fed4f15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed4f15",
  null
  
)

export default component.exports